import styled from "@emotion/styled";
import { Separator, type SeparatorProps } from "react-aria-components";

interface Props extends SeparatorProps {}

export const StyledSeparator = styled(Separator)<Props>(({ orientation, theme }) => ({
  background: theme.colors.border.default,
  ...(orientation === "vertical"
    ? {
        width: "1px",
        height: "auto",
        alignSelf: "stretch",
        margin: `0 ${theme.spacing["2"]}`,
      }
    : {
        height: "1px",
        width: "auto",
        alignSelf: "stretch",
        margin: `${theme.spacing["2"]} 0`,
      }),
  flexShrink: 0,
}));
